import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#030b07] border-t text-cream/70 font-body text-sm select-none" style={{ borderColor: 'rgba(201,168,76,0.08)' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6 mb-12">
          
          {/* Column 1: Brand Info */}
          <div className="space-y-4">
            <h3 className="font-display text-2xl text-cream tracking-wide">Just Original</h3>
            <p className="text-cream/40 text-xs leading-relaxed max-w-xs">
              Experience the essence of authentic luxury perfumery. Discover our range of signature long-lasting fragrances crafted for the sophisticated mind.
            </p>
          </div>

          {/* Column 2: Quick Shop Links */}
          <div className="space-y-4">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-medium">Collections</h4>
            <ul className="space-y-2.5 text-xs">
              <li><Link to="/products" className="hover:text-gold transition-colors">All Fragrances</Link></li>
              <li><Link to="/products?category=men" className="hover:text-gold transition-colors">For Him</Link></li>
              <li><Link to="/products?category=women" className="hover:text-gold transition-colors">For Her</Link></li>
              <li><Link to="/products?category=unisex" className="hover:text-gold transition-colors">Unisex Range</Link></li>
            </ul>
          </div>

          {/* Column 3: Razorpay Compliance & Support Links */}
          <div className="space-y-4">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-medium">Customer Support</h4>
            <ul className="space-y-2.5 text-xs">
              <li><Link to="/contact" className="hover:text-gold transition-colors">Contact Us</Link></li>
              <li><Link to="/shipping-policy" className="hover:text-gold transition-colors">Shipping & Delivery</Link></li>
              <li><Link to="/refund-policy" className="hover:text-gold transition-colors">Returns & Refunds</Link></li>
            </ul>
          </div>

          {/* Column 4: Legal & Compliance Links */}
          <div className="space-y-4">
            <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-medium">Legal</h4>
            <ul className="space-y-2.5 text-xs">
              <li><Link to="/privacy-policy" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-gold transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-cream/30" style={{ borderColor: 'rgba(201,168,76,0.05)' }}>
          <p>&copy; 2026 Just Original Perfumes. All Rights Reserved.</p>
          <div className="flex items-center gap-2">
            <span className="text-[10px] tracking-widest uppercase text-gold/40">Secure Payments via Razorpay</span>
          </div>
        </div>
      </div>
    </footer>
  );
}